import api from '@api/Api';

export default {

    getCampaign(id) {
        return api().get(`/campaigns/${id}`);
    },

    updateCampaign(id, params, step = null) {
        return api().put(`/campaigns/${id}`, { ...params, step: step });
    },

    startCampaign(id) {
        return api().put(`/campaigns/${id}/start`);
    },

    stopCampaign(id) {
        return api().put(`/campaigns/${id}/stop`);
    },

    updateCampaignName(id, name) {
        return api().put(`/campaigns/${id}/name`, { name: name });
    },

    duplicateCampaign(id) {
        return api().post(`/campaigns/${id}/duplicate`);
    },

    deleteCampaign(id) {
        return api().delete(`/campaigns/${id}`);
    },

}
